<template>
  <div class="cover-lineamientos a11y-ocultar-imagen-link">
    <div class="container">
      <h4 class="titular texto-centrado titulo-left-movil">
        Lineamientos del programa
      </h4>
      <div class="container text">
        <p>El Programa de formación contempla cuatro perfiles de ingreso,
        la selección de candidatas(os) se basa en procesos equitativos, inclusivos y de paridad
        de género:</p>
      <div class="container-lineamientos">
        <div class="flex-1_2">
            <img class="imagen" alt=" " src="../assets/icons/jovenes-icon.svg">
            <p><strong>Jóvenes con grado de licenciatura</strong></p>
            <p class="lineamiento">En áreas del conocimiento afines a la agricultura ecológica</p>
        </div>
        <div class="flex-1_2">
          <img class="imagen" alt=" " src="../assets/icons/docentes.svg">
          <p><strong>Docentes</strong></p>
          <p class="lineamiento">De medio tiempo</p>
        </div>
        <div class="flex-1_2">
          <img class="imagen" alt=" " src="../assets/icons/promotores-icon.svg">
          <p><strong>Promotores – formadores</strong></p>
          <p class="lineamiento">En procesos de formación y capacitación en agroecologías y cuidado del territorio y de
            medio tiempo</p>
        </div>
        <div class="flex-1_2">
          <img class="imagen" alt=" " src="../assets/icons/actores.svg">
          <p class="titulo-lineamiento"><strong>Actores locales</strong></p>
          <p class="lineamiento">Con amplio reconocimiento de su comunidad en procesos de producción agroecológica,
            defensa del territorio o formación de capacidades</p>
        </div>
      </div>
      <div class="container texto-centrado">
        <router-link class="boton-ciatej btn-bold" to="/capsulas">
          Ir a cápsulas
        </router-link>
      </div>
      </div>
      <div class="container m-t-1-sm m-b-2-sm m-y-3">
        <div class="video-responsivo">
          <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen frameborder="0"
                  height="315" src="https://www.youtube.com/embed/8MKb_IgExs4"
                  title="YouTube video player"
                  width="560"></iframe>
        </div>
        <div class="container texto-centrado a11y-simplificada-block container-video">
          <a class="boton-plataforma btn-bold" href="https://www.youtube.com/watch?v=8MKb_IgExs4" target="_blank">
            Ir al video de Convocatoria PIES AGILES
          </a>
        </div>
      </div>
      <div class="container texto-centrado">
        <button class="boton-plataforma btn-bold a11y-enlace-subrayado" onclick="window.open('https://alimentacion.conacyt.mx/piesagiles/lms/login/index.php', '_blank')">
          Ir a la plataforma educativa
        </button>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "Lineamientos"
}
</script>

<style lang="scss">
.cover-lineamientos {
  background-color: #F5F5F5;
  background-size: cover;
  width: 100%;
  opacity: 1;
  margin-top: $gap;
  padding-top: $gap;
  padding-bottom: $gap;
}

.boton-plataforma{
  top: 3728px;
  left: 546px;
  width: 274px;
  height: 51px;
  color: #D13560;
  background: #F5F5F5;
  border: 2px solid #D13560;
  border-radius: 5px;
  opacity: 1;
  align-self: center;
}
.boton-plataforma:hover{
  background-color: white;
  box-shadow: 2px 2px 10px #00000029;
  color: #D13560;
}
.boton-plataforma:focus{
  background-color: #D1889D;
  color: #FFFFFF;
}

.container-lineamientos {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.boton-ciatej {
  top: 4106px;
  left: 616px;
  width: 135px;
  height: 51px;
  color: #d13560;
  background: #ffffff;
  border: 2px solid #d13560;
  border-radius: 5px;
  opacity: 1;
  align-self: center;
  justify-content: center;
  padding: 13px 4px;
}

.boton-ciatej:hover {
  color: #d13560;
  background-color: white;
  box-shadow: 2px 2px 10px #00000029;
}

.boton-ciatej:focus {
  background-color: #d1889d;
  color: #ffffff;
}

.flex-1_2 {
  flex: 1 0 100%;
  margin-bottom: $gap;
  padding-top: calc(#{$gap*0.5} + 2%);
  padding-bottom: calc(#{$gap*0.5} + 2%);
  overflow: hidden;
  position: relative;
  text-align: center;
  .lineamiento {
    padding: 0 calc(38px) 0 calc(38px);
  }
}

@media (min-width: map-get($media-queries-limit, "mobile")) {
  .flex-1_2 {
    flex: 1 0 50%;
    max-width: calc(50% - #{$gap*0.5});
    margin-bottom: $gap;
    text-align: center;
    .lineamiento {
    padding: 0 calc(58px) 0 calc(58px);
  }
    
  }
}



.video-responsivo {
  overflow: hidden;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;}
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }


</style>
